import GkdAuthParams from '../../types/GkdAuthParams'
import getBaseUrl from '../../utils/getBaseUrl/getBaseUrl'
import cleanObject from './cleanObject'
import convertLocale from './convertLocale'
import ErrorWithContext from '../components/ErrorBoundary/ErrorWithContext'

export type FetchContentParams = {
  locale: string
  legacyOSMClientId?: string
  bespokeId?: string
  adServerUrl?: string
  purchaseAmount?: string
  customPaymentMethodIds?: string
  messagePreference?: string
  subscriptionInterval?: string
  path?: string
  shoppingSessionId?: string
  redirectUrl?: string
  intents?: string[]
  subscriptionBillingInterval?: string
  subscriptionBillingIntervalFrequency?: number
} & GkdAuthParams;

export default async function fetchContent({
  locale,
  clientId,
  legacyOSMClientId,
  integratorOrigin,
  accountId,
  bespokeId = 'default',
  purchaseAmount,
  customPaymentMethodIds,
  adServerUrl,
  messagePreference,
  subscriptionInterval,
  shoppingSessionId,
  redirectUrl,
  path = 'v3/messaging',
  intents,
  subscriptionBillingInterval,
  subscriptionBillingIntervalFrequency,

}: FetchContentParams) {
  const queryString = new URLSearchParams(cleanObject({
    locale: convertLocale(locale),
    client_id: legacyOSMClientId, // if clientId (GKD Auth) is passed this value will be empty, and will be removed in cleanObject func
    placement_key: bespokeId.includes('revamped') ? 'payment-calculator-interstitial' : bespokeId,
    purchase_amount: purchaseAmount,
    channel: 'web',
    custom_payment_method_ids: customPaymentMethodIds,
    message_preference: messagePreference,
    subscription_interval: subscriptionInterval,
    shopping_session_id: shoppingSessionId,
    intents,
    subscription_billing_interval: subscriptionBillingInterval,
    subscription_billing_interval_frequency: subscriptionBillingIntervalFrequency,
  })).toString()

  const baseUrl = adServerUrl || getBaseUrl(locale) || process.env.CMA_BASE_URL
  const headers = {
    'Klarna-Client-Type': 'klarna-web-sdk'
  }

  if (redirectUrl && redirectUrl !== '') {
    headers['x-klarna-redirect-url'] = redirectUrl
  }

  let url = `${baseUrl}/${path}?${queryString}`

  if (clientId && integratorOrigin) {
    url = url.replace('v3', 'v4')
    headers['Authorization'] = `basic ${clientId}`
    headers['Klarna-Integrator-Origin'] = integratorOrigin
    if (accountId) headers['Klarna-Account'] = accountId
  }

  const res = await fetch(url, { headers })
  if (res.status === 404 || res.status === 204) {
    throw new ErrorWithContext('Failed to find interstitial ad')
  }

  let data
  const backupRes = res.clone()
  try {
    data = await res.json()
  } catch (err) {
    const responseAsText = await backupRes.text()
    throw new ErrorWithContext(`[fetchContent Error]: ${err.message}`, {
      responseBody: responseAsText,
      responseStatus: res.status
    })
  }

  return path.includes('prequalification') ? data : data.content
}
